import { render, staticRenderFns } from "./OrderRecord2.vue?vue&type=template&id=a5c045d8&scoped=true"
import script from "./OrderRecord2.vue?vue&type=script&lang=js"
export * from "./OrderRecord2.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord2.vue?vue&type=style&index=0&id=a5c045d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c045d8",
  null
  
)

export default component.exports